import script from "./AdminDashboardBulkUploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardBulkUploadModal.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboardBulkUploadModal.vue?vue&type=style&index=0&id=48bf54a9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48bf54a9"]])

export default __exports__